<script lang="ts">
  import { params } from "@roxi/routify";

  // services
  import { HttpPromise } from "@shared/svelte/Modules/ApiService";
  import { stagedRolloutCheck } from "@shared/svelte/Modules/StagedRolloutCheck.svelte";
  import { shouldUseRetailerFulfillmentMethodForDistributor } from "@retailer/services/fulfillment_methods_service";

  // components
  import SellSheetBuy from "@modern/components/retailer/SellSheet/SellSheetBuy.svelte";
  import Spinner from "@shared/svelte/Components/SpinnerInternal.svelte";

  // stores
  import FuturePricesStore from "@shared/svelte/Stores/FuturePricesStore.js";
  import RetailerFulfillmentMethodsStore from "@retailer/svelte/stores/RetailerFulfillmentMethodsStore";
  import StateSettingsStore from "@shared/svelte/Stores/StateSettingsStore";

  // SF list have string ids, Provi ids are numeric
  const isSFList = isNaN(parseFloat($params.id)) && !isFinite($params.id);

  const fetchSellSheet = async () => {
    const apiParams = $params.account ? `${$params.id}?account=${$params.account}` : $params.id;
    const sellSheet = await HttpPromise({
      method: "GET",
      url: "/api/retailer/sell_sheets/" + apiParams,
      data: {
        ssid: $params["ssid"],
      },
    });
    return sellSheet;
  };

  const fetchStateSettings = async () => {
    const stateSettings = await HttpPromise({
      method: "GET",
      url: "/api/retailer/state_settings",
    });
    StateSettingsStore.set(stateSettings);
  };

  const fetchFuturePrices = async (inventoryIds: number[], distributorId: number) => {
    const response = await HttpPromise({
      method: "GET",
      url: `/api/retailer/future_prices`,
      data: {
        inventory_ids: inventoryIds,
        distributor_id: distributorId,
      },
    });
    const futurePrices = response.future_prices;
    FuturePricesStore.set(futurePrices);
  };

  const load = async () => {
    const sellSheetPromises = [fetchSellSheet(), fetchStateSettings()];
    const sellSheetResults = await Promise.all(sellSheetPromises);
    const sellSheet = sellSheetResults[0];

    const inventoryIds = sellSheet.product_lines
      .flatMap(pl => pl.sell_sheet_products_attributes.map(p => p.cloned_from_inventory_id))
      .filter(id => id !== null);
    const distributorId = isSFList
      ? sellSheet.product_lines[0]?.distributor?.id
      : sellSheet.distributor?.id;

    if (
      shouldUseRetailerFulfillmentMethodForDistributor(
        sellSheet.distributor?.id,
        sellSheet.distributor?.uses_warehouse_pickup,
        stagedRolloutCheck("marketplace__fulfillment_methods") &&
          sellSheet.distributor?.uses_wine_cellar,
      )
    ) {
      RetailerFulfillmentMethodsStore.updateDistributorFulfillmentMethod(sellSheet.distributor?.id);
    }

    if (inventoryIds.length && distributorId) {
      await fetchFuturePrices(inventoryIds, distributorId);
    }

    return sellSheet;
  };
</script>

{#await load()}
  <Spinner />
{:then sellSheet}
  <SellSheetBuy {sellSheet} showProductLinks={true} {isSFList} />
{/await}
